import { ChangeEvent, FormEvent, useState } from 'react';
import useTranslation from 'shared/hooks/useTranslation';
import styled from 'styled-components';
import { Input } from 'shared/components/Styled';
import Button from 'shared/components/Button';

const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 33rem;
  padding: 1rem;

  ${({ theme }) => theme.MEDIA.SM} {
    width: 42rem;
  }

  ${({ theme }) => theme.MEDIA.MD} {
    width: 64rem;
    margin: 2rem;
  }

  ${({ theme }) => theme.MEDIA.XL} {
    width: 80rem;
  }
`;

const StyledButton = styled(Button)`
  max-width: 20rem;
  height: 6rem;
  margin-left: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SearchInput = styled(Input)`
  display: block;
  font-size: 16px;
  height: 6rem;
  width: 100%;
  margin: 2.4rem 0;
`;

type SearchFormProps = {
  handleSubmit: (e: FormEvent<HTMLFormElement>, search: string) => void;
};

function SearchForm({ handleSubmit }: SearchFormProps): JSX.Element {
  const { t } = useTranslation('findCompanyPage');
  const [search, setSearch] = useState('');

  return (
    <form onSubmit={(e) => handleSubmit(e, search)}>
      <FormWrapper>
        <SearchInput
          aria-label="Search"
          name="search"
          value={search}
          placeholder={t('form.inputPlaceholder')}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
        />
        <StyledButton type="submit" data-testid="search-button">
          {t('form.buttonCta')}
        </StyledButton>
      </FormWrapper>
    </form>
  );
}

export default SearchForm;
